import createModuleStorage from "app/pages/sales-intelligence/services/storage/factory";

const opportunityListsStorageProvider = createModuleStorage(localStorage, "si:opportunity-lists");

export default opportunityListsStorageProvider;
